import styled from 'styled-components';
import ds from 'designsystem';

const LI = styled.li`
  color: ${ds.brand('text')};
  position: relative;
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.light')};
  font-size: ${ds.fs('blogArticleParagraph')};
  line-height: ${ds.get('type.lineHeight.s')};
  margin: 10px 0;
`;

export default LI;



// WEBPACK FOOTER //
// ./src/elements/LI.js